import {useMutation, useQueryClient} from "@tanstack/react-query";
import {AxiosError} from "axios";
import {useModal} from "../../../../../hooks";
import {updateDashboardHiddenSetting} from "../../../../../api/main/DashboardApi";
import {DashboardSettingListElementType} from "../../detail/interface";

interface Props {
    closeCallback: () => any
}

export const useUpdateDashboardHiddenSetting = ({closeCallback}: Props) => {
    const {handleModal} = useModal();
    const qc = useQueryClient();

    const {mutate, mutateAsync} = useMutation({
        mutationFn: (data: DashboardSettingListElementType[]) => updateDashboardHiddenSetting(data),
        onSuccess: (res) => {
            if (res.data.code === "0000") {
                handleModal({
                    isOpen: true,
                    contents: "수정되었습니다.",
                    type: "alert",
                    closeAction: () => {
                        qc.invalidateQueries({queryKey: ["readDashboardSetting"]})
                        closeCallback()
                    }
                })
            }
        },
        onError: (error: AxiosError<{ msg?: string }>) => {
            if (error?.response?.data?.msg) {
                handleModal({
                    isOpen: true,
                    contents: error?.response?.data?.msg,
                    type: "alert",
                });
            }
        },
    });

    return {mutate, mutateAsync};
};
